import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings.js";
import demo1 from "images/assests/aptScreen.png";
import demo2 from "images/assests/patient.png";
import demo3 from "images/assests/billing.png";
import demo4 from "images/assests/insurance.png";
import demo5 from "images/assests/inventory.png";
import demo6 from "images/assests/clinical.png";
import demo7 from "images/assests/reports.png";
import demo8 from "images/assests/integrations.png";
import demo9 from "images/assests/dashboard.png";
import demo10 from "images/demo/PrivacyPolicyPage.jpeg";
import demo11 from "images/demo/RestaurantLandingPage.jpeg";
import demo12 from "images/demo/SaaSProductLandingPage.jpeg";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg";
import { SectionDescription } from "components/misc/Typography";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24 items-center`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(
  Column
)`md:w-5/12 flex-shrink-0 relative h-96 overflow-hidden`;

const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center m-auto`;

const Image = styled.img((props) => [
  props.imageRounded && tw`rounded`,
  props.imageBorder && tw`border`,
  props.imageShadow && tw`shadow`,
]);

const DecoratorBlob = styled(SvgDotPattern)((props) => [
  tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`,
]);

// my style

const ThreeColumnContainer = styled.div((props) => [
  tw`md:w-7/12 w-full mt-16 md:mt-0 mt-10 flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap lg:justify-center overflow-hidden`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const ThreeColumn = styled.div`
  ${tw`lg:w-1/3 max-w-xs`}
`;

const Card = styled.div`
  ${tw`flex flex-col text-left h-full mx-4 px-4 py-4 rounded transition-transform duration-300 hover:cursor-pointer transform hover:scale-105 `}

  &:hover {
    ${tw`bg-gray-300 text-gray-700`}
  }

  .title {
    ${tw`mt-4 font-bold text-xl leading-none`}
  }

  .description {
    ${tw`mt-4 text-sm font-medium text-secondary-300`}
  }
`;

export default ({
  heading = (
    <>
      Everything you need, we have in{" "}
      <span tw="text-primary-500">Tabebek.</span>
    </>
  ),
  description = "Experience all the amazing features for your clinic.",
  imageRounded = true,
  imageBorder = false,
  imageShadow = false,
  imageCss = null,
  imageDecoratorBlob = false,
  imageDecoratorBlobCss = null,
}) => {
  const [hoveredImg, setHoveredImg] = useState(demo1);

  const handleCardHover = (imgUrl) => {
    setHoveredImg(imgUrl);
  };

  const cards = [
    {
      title: "Scheduling",
      imageSrc: demo1,
      description: "Flexible single and bulk appointment with more features.",
    },
    {
      title: "Patients",
      imageSrc: demo2,
      description: "A Comprehensive module with complete health records.",
    },
    {
      title: "Billing",
      imageSrc: demo3,
      description: "Simplified single screen invoice creation.",
    },
    {
      title: "Insurance",
      imageSrc: demo4,
      description: "A Comprehensive module for your insurance billing.",
    },
    {
      title: "Inventory",
      imageSrc: demo5,
      description: "A complete soluton to manage your clinics inventory.",
    },
    {
      title: "Clinical Module",
      imageSrc: demo6,
      description:
        "A top featured doctor module for a complete patient health journey.",
    },
    {
      title: "Reports",
      imageSrc: demo7,
      description:
        "A Comprehensive analytics to see day-to-day performance of your clinic.",
    },
    {
      title: "Integrations",
      imageSrc: demo8,
      description: "Integrated with MOH applications.",
      // "Integrated health insurance modules with NPHIES(MOH), DHS and waseel",
    },
    {
      title: "Dashboards",
      imageSrc: demo9,
      description:
        "A Quick glimpse of clinics data is presented in graphical interfaces.",
    },
  ];

  return (
    <Container>
      <Heading>{heading}</Heading>
      {description && <Description>{description}</Description>}
      <TwoColumn>
        <ImageColumn>
          <Image
            css={imageCss}
            src={hoveredImg}
            imageBorder={imageBorder}
            imageShadow={imageShadow}
            imageRounded={imageRounded}
          />
          {imageDecoratorBlob && <DecoratorBlob css={imageDecoratorBlobCss} />}
        </ImageColumn>
        <ThreeColumnContainer textOnLeft={true}>
          {cards.map((card, i) => (
            <ThreeColumn key={i}>
              <Card onMouseOver={() => handleCardHover(card?.imageSrc)}>
                <span className="title">{card.title}</span>
                <p className="description">{card.description}</p>
              </Card>
            </ThreeColumn>
          ))}
        </ThreeColumnContainer>
      </TwoColumn>
    </Container>
  );
};
